import { render, staticRenderFns } from "./MesaDeExamenNoviembre2025.vue?vue&type=template&id=5d298362&"
import script from "./MesaDeExamenNoviembre2025.vue?vue&type=script&lang=js&"
export * from "./MesaDeExamenNoviembre2025.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports